import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import type { HelpdeskTaskFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/helpdesk-task-find.dto';
import { CrmTableColumn } from '@zaoblako/web/core/models/crm-table-column.interface';
import { HdPrefixService } from '@zaoblako/web/core/services/prefix/hd-prefix.service';
import { ConditionalRouterLinkDirective } from '@zaoblako/web/shared/directives/conditional-router-link.directive';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { TableComponent } from '@zaoblako/web/shared/dumbs/table/table.component';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'crm-created-tasks-widget',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    TableComponent,
    ButtonComponent,
    SpinnerComponent,
    ConditionalRouterLinkDirective
  ],
  templateUrl: './created-tasks-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreatedTasksWidgetComponent {
  @Input() public tasks: HelpdeskTaskFindInterface[];
  @Input() public loading: boolean;

  @Output() public directToTasksList = new EventEmitter<void>();

  public columns: CrmTableColumn[] = [{ label: 'Название' }, { label: 'Дата' }];

  public constructor(public readonly hdPrefixService: HdPrefixService) {}

  public toTask(task: any): HelpdeskTaskFindInterface {
    return task as HelpdeskTaskFindInterface;
  }
}
